import { Language } from './Enums/Language'

// Official DKK/EUR central rate (Denmark's krone is pegged to the euro via
// ERM II) — used to show marketing/subscription prices in EUR for the
// German/English interfaces. Does NOT apply to real user data (budget and
// accounting amounts) — those stay in DKK until proper multi-currency
// support exists.
const DKK_TO_EUR_RATE = 7.46

// All prices are defined in DKK (Config.PRICE_*). For non-Danish languages,
// convert to EUR and round up, so displayed prices are never undercharged
// relative to what gets manually invoiced. `priceEurOverride` mirrors the
// WWW pricing page's `priceEur` field for plans where the rounded-up
// conversion doesn't match the price actually shown/charged there.
export const priceForLanguage = (
  priceInDkk: number,
  language: string,
  priceEurOverride?: number,
): number =>
  language === Language.DANISH
    ? priceInDkk
    : (priceEurOverride ?? Math.ceil(priceInDkk / DKK_TO_EUR_RATE))

export default {
  API: process.env.REACT_APP_API,
  PRICE_BUDGET: 49,
  PRICE_ACCOUNTING: 29,
  // WWW pricing page shows kr. 9 / €1 (see www/src/content/pages/*/priser.md).
  PRICE_SPREADSHEET: 9,
  PRICE_SPREADSHEET_EUR: 1,
  // Each locale's WWW marketing site is a separate domain (see root README).
  WWW_DOMAIN: {
    [Language.DANISH]: 'https://privat-økonomi.dk',
    [Language.GERMAN]: 'https://privatfinanzen.eu',
    [Language.ENGLISH]: 'https://personal-finance.io',
  } as Record<Language, string>,
}
